import React, { useContext } from 'react'
import { AppContext } from 'contexts/AppContext'
import Notifier from '../Notifier'
import { Notification } from '../types'
import './NotifierQueue.scss'

const NotifierQueue: React.FC = () => {
  const { notifications, removeNotification } = useContext(AppContext)

  return (
    <div className='NotifierQueue'>
      {notifications.map((n: Notification) => (
        <Notifier
          key={n.id}
          id={n.id}
          type={n.type}
          text={n.text}
          time={n.time}
          onRemoveNotification={removeNotification}
        />
      ))}
    </div>
  )
}

export default NotifierQueue
